import SkippingSteps from '@images/Stepper-skipping steps.png';
import * as React from 'react';
export default {
  SkippingSteps,
  React
};